import "./RegisteredDrivers.scss"
import { Button, Typography } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { Driver } from "../../../types/driverTypes"
import DriverItem from "./DriverItem/DriverItem.component"
import { isDisconnectBtnVisible } from "../../../utils/utils"

type RegisteredDriversProps = {
  driversList: Driver[],
  setSelectedDriver: (driver: Driver) => void
}

export const RegisteredDrivers = ({ driversList, setSelectedDriver }: RegisteredDriversProps) => {
  const dispatch = useAppDispatch()
  const customerTypeId = useAppSelector((state) => state.auth.userData?.personal.customerTypeId);
  const isMobile = useIsMobile()

  const { REGISTERED_DRIVERS_TITLE, ADD_A_DRIVER } = useTranslationLabel()

  const handleAddDriverClicked = () => {
    dispatch(showModal({ activeModal: ModalTypes.ADD_DRIVER_MODAL }))
  }

  const handleAddDisconectDriver = (driver: Driver) => {
    setSelectedDriver(driver);
    dispatch(showModal({ activeModal: ModalTypes.DISCONNECT_MODAL }))
  }

  return (
    <div className="registered-drivers-container">
      <div className="top-section">
        <Typography variant="h4" className="title">
          {REGISTERED_DRIVERS_TITLE}
        </Typography>
        {!isMobile && (
          <Button
            className="primary-btn"
            variant="contained"
            onClick={handleAddDriverClicked}
          >
            {ADD_A_DRIVER}
          </Button>
        )}
      </div>
      <div className="drivers-list">
        {driversList.map((driver: Driver) => (
          <DriverItem
            key={driver.id}
            driver={driver}
            showDisconectBtn={isDisconnectBtnVisible(
              driver.driverStatusId,
              customerTypeId,
            )}
            handleAddDisconectDriver={handleAddDisconectDriver}
          />
        ))}
      </div>
      <br />
      {isMobile && (
        <Button
          className="primary-btn"
          variant="contained"
          onClick={handleAddDriverClicked}
        >
          {ADD_A_DRIVER}
        </Button>
      )}
    </div>
  )
}
